import { BaseContainerModel } from "../base-container.model";
import { bl_wms_container_hdr_RowInterface, bl_wms_container_hdr_RowClass,
    bl_wms_container_line_RowClass, bl_wms_grn_container_link_RowClass } from "../../dbschema/index";

export class WmsContainerModel extends BaseContainerModel {
    bl_wms_container_hdr: bl_wms_container_hdr_RowInterface = new bl_wms_container_hdr_RowClass();
    bl_wms_container_lines: bl_wms_container_line_RowClass[] = [];
    bl_wms_grn_container_links: bl_wms_grn_container_link_RowClass[] = [];
}
